import { useState } from "react";
import { aadharPlaceholder, document, pancard } from "../../../asset";
import { CustomButton } from "../../../components";
import DocumentUpload from "../../../components/common/DocumetUpload";
import SubHeadings from "../../../components/SubHeadings";
import { useEditMode } from "../../../context/EditModeContext";
import { Staff } from "../../../types/staff";
import StaffApis from "../../../api/staffApis";

interface DocProps {
  staff?: Staff;
  onChange: (data: Partial<Staff>) => void;
}

export default function DocumentDetails({ staff, onChange }: DocProps) {
  const { isEditing } = useEditMode();

  const [loading, setLoading] = useState(false);

  const handleVerifyDocument = async () => {
    if (!staff?.staffId) return;

    try {
      setLoading(true);
      await StaffApis.verifyDocument(staff.staffId);

      // update UI state
      onChange({ isDocVerified: true });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="md:px-9 px-4 pb-20">
      <div className="flex flex-col gap-7 w-full py-7">
        <div className="flex justify-between items-center">
          <SubHeadings text="Document Details" />
          <div className="flex justify-end">
            <CustomButton
              text={
                staff?.isDocVerified ? "Document Verified" : "Verify Document"
              }
              color={
                staff?.isDocVerified ? "bg-success-500" : "bg-primary-500"
              }
              onClick={handleVerifyDocument}
              disabled={staff?.isDocVerified || loading || !isEditing}
            />
          </div>
        </div>
        <div className="grid lg:grid-cols-3 max-w-lg mx-auto lg:max-w-7xl lg:w-full h-full gap-y-24 lg:gap-16">
          <DocumentUpload
            label="Aadhaar Card"
            value={staff?.aadharCardUrl}
            onUploadComplete={(url) => {
              onChange({ aadharCardUrl: url });
            }}
            placeholderImage={aadharPlaceholder}
            borderStyle="solid"
            buttonWidth="fit"
            buttonAlign="right"
            buttonText="Upload"
            className="w-full"
            disabled={!isEditing}
          />
          <DocumentUpload
            label="PAN card"
            value={staff?.panCardUrl}
            onUploadComplete={(url) => {
              onChange({ panCardUrl: url });
            }}
            placeholderImage={pancard}
            borderStyle="solid"
            buttonWidth="fit"
            buttonAlign="right"
            buttonText="Upload"
            className="w-full"
            disabled={!isEditing}
          />
          <DocumentUpload
            label="Highest qualification documents"
            value={staff?.qualificationDocUrl}
            onUploadComplete={(url) => {
              onChange({ qualificationDocUrl: url });
            }}
            placeholderImage={document}
            borderStyle="solid"
            buttonWidth="fit"
            buttonAlign="right"
            buttonText="Upload"
            className="w-full"
            disabled={!isEditing}
          />
        </div>
      </div>
    </div>
  );
}
